import { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import "../User_Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { AuthLogin } from "../../../features/auth/Slice";
import { Context } from "../../../utils/context";
import { jwtDecode } from "jwt-decode";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Create } from "../../../features/admin/auth/Slice";
import { useLocation } from "react-router-dom";
import HotelRegistration from "../../registration_forms/hotelRegistration/HotelRegistration";
import StudentRegistration from "../../registration_forms/studentRegistration/StudentRegistration";
import CollageRegistration from "../../registration_forms/collageRegistration/CollageRegistration";

const User_registration = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [selectedPartner, setSelectedPartner] = useState(
    location.state?.partner || null,
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    watch,
  } = useForm({});

  const password = watch("password");

  const ROLE_MAP = {
    student: 4,
    college: 3,
    hotel: 2,
  };

  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");
  const { setSignin, getuserData } = useContext(Context);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onSubmit = async (data) => {
    try {
      if (!selectedPartner) {
        setError("name", {
          type: "manual",
          message: "Please select a partner type",
        });
        return;
      }

      const payload = {
        name: data.name,
        contact_no: data.contact_no,
        email: data.email,
        password: data.password,
        role_id: ROLE_MAP[selectedPartner], // ✅ numeric role_id
      };

      const res = await dispatch(Create(payload)).unwrap();

      // ✅ SUCCESS
      const token = res.data.token;
      Cookies.set("af_mobility_security", token, { expires: 365 });

      setSignin(true);
      await getuserData();

      const DASHBOARD_ROUTE = {
        student: "/portal/student/dashboard",
        college: "/portal/college/college-dashboard",
        hotel: "/portal/hotel/hotel-dashboard",
        admin: "/portal/admin/admin-dashboard",
      };

      navigate(DASHBOARD_ROUTE[selectedPartner]);
    } catch (error) {
      setError("email", {
        type: "manual",
        message: error || "Registration failed",
      });
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (!selectedPartner) return;

    const DASHBOARD_ROUTE = {
      student: "/dashboard",
      college: "/college-dashboard",
      hotel: "/hotel-dashboard",
      admin: "/admin-dashboard",
    };

    navigate(`/portal/${selectedPartner}${DASHBOARD_ROUTE[selectedPartner]}`);
  };

  if (!selectedPartner) {
    navigate("/");
    return null;
  }

  return (
    <>
      <section className="login_wrapper">
        <div className={`login_div ${selectedPartner ? "login_mode" : ""}`}>
          <div className="row justify-content-center">
            {/* ============== Left Side ================ */}
            <div className="col-lg-6 col-md-11 order-2 order-lg-1">
              <div className="left_content">
                <h1 className="main_heading">
                  From recruitment to contracts All in One Place
                </h1>

                <p className="main_text">
                  Seamlessly apply, hire, & manage every step of the internship
                  process with confidence.
                </p>

                <div className="feature_box">
                  <h5 className="feature_heading">SEAMLESS PROCESS</h5>
                  <p className="feature_text">
                    Submit your documents online, get them reviewed, and receive
                    approvals faster
                  </p>
                </div>

                <div className="feature_box">
                  <h5 className="feature_heading">ALL IN ONE</h5>
                  <p className="feature_text">
                    Apply for internships, post offers, upload CDD documents,
                    and track your applications
                  </p>
                </div>

                <div className="feature_box">
                  <h5 className="feature_heading">TRANSPARENT & RELIABLE</h5>
                  <p className="feature_text">
                    Every step is verified by experts available 24/7 to guide
                    you
                  </p>
                </div>

                <h2 className="tagline">We Nurture Talent Across The Globe</h2>
              </div>
            </div>

            {/* ============== Right Side ================ */}
            <div className="col-lg-6 col-md-11 order-1 order-lg-2">
              <StudentRegistration />
              {/* <CollageRegistration/> */}
              {/* <HotelRegistration/> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default User_registration;
